'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'life-ring';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f1cd';
var svgPathData = 'M459.3 436.7C465.6 442.9 465.6 453.1 459.3 459.3C453.1 465.6 442.9 465.6 436.7 459.3L425.4 447.1C380.2 487.8 320.9 512 256 512C191.1 512 131.8 487.8 86.65 447.1L75.31 459.3C69.07 465.6 58.93 465.6 52.69 459.3C46.44 453.1 46.44 442.9 52.69 436.7L64.02 425.4C24.18 380.2 0 320.9 0 256C0 191.1 24.18 131.8 64.02 86.65L52.69 75.31C46.44 69.07 46.44 58.93 52.69 52.69C58.93 46.44 69.06 46.44 75.31 52.69L86.65 64.02C131.8 24.18 191.1 0 256 0C320.9 0 380.2 24.18 425.4 64.02L436.7 52.69C442.9 46.44 453.1 46.44 459.3 52.69C465.6 58.93 465.6 69.06 459.3 75.31L447.1 86.65C487.8 131.8 512 191.1 512 256C512 320.9 487.8 380.2 447.1 425.4L459.3 436.7zM311.6 334.3C295.9 345.4 276.7 352 256 352C235.3 352 216.1 345.4 200.4 334.3L109.3 425.3C148.6 459.4 199.9 480 256 480C312.1 480 363.4 459.4 402.7 425.3L311.6 334.3zM480 256C480 199.9 459.4 148.6 425.3 109.3L334.3 200.4C345.4 216.1 352 235.3 352 256C352 276.7 345.4 295.9 334.3 311.6L425.3 402.7C459.4 363.4 480 312.1 480 256V256zM256 32C199.9 32 148.6 52.62 109.3 86.7L200.4 177.7C216.1 166.6 235.3 159.1 256 159.1C276.7 159.1 295.9 166.6 311.6 177.7L402.7 86.7C363.4 52.62 312.1 32 256 32zM177.7 311.6C166.6 295.9 160 276.7 160 256C160 235.3 166.6 216.1 177.7 200.4L86.7 109.3C52.62 148.6 32 199.9 32 256C32 312.1 52.62 363.4 86.7 402.7L177.7 311.6zM256 192C220.7 192 192 220.7 192 256C192 291.3 220.7 320 256 320C291.3 320 320 291.3 320 256C320 220.7 291.3 192 256 192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLifeRing = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;